/**
 * Loughran-McDonald Sentiment Quantum Gauge Component
 */

import { SentimentType } from './types';

export function renderSentimentGauge(score: number, sentiment: SentimentType): string {
  const rawScore = typeof score === 'number' ? score : 0.0;
  const scoreSign = rawScore > 0 ? '+' : '';
  const scoreFormatted = `${scoreSign}${rawScore.toFixed(2)}`;

  let labelText = 'NEUTRAL';
  if (sentiment === 'positive') labelText = 'BULLISH';
  else if (sentiment === 'negative') labelText = 'BEARISH';

  // Calculate pointer position (clamped 4% to 96%)
  const pointerLeft = Math.max(4, Math.min(96, Math.round(((rawScore + 1.0) / 2.0) * 100)));

  return `
    <div class="wire-window-gauge-box">
      <div class="wire-window-gauge-top">
        <span class="gauge-lbl">LOUGHRAN-MCDONALD VALENCE</span>
        <span class="gauge-score ${sentiment}">${scoreFormatted} (${labelText})</span>
      </div>
      <div class="wire-window-gauge-track">
        <div class="wire-window-gauge-needle" style="left: ${pointerLeft}%;"></div>
      </div>
      <div class="wire-window-gauge-scales">
        <span>-1.0 BEARISH</span>
        <span>0.0 NEUTRAL</span>
        <span>+1.0 BULLISH</span>
      </div>
    </div>
  `;
}
